export const categories = [
  {
    id: 'yule',
    name: '娱乐',
    slug: 'yule',
    icon: 'ri-movie-line',
    description: '综艺节目、搞笑短片、明星访谈等娱乐内容，让你开怀大笑',
    videoCount: 128,
  },
  {
    id: 'jiaocheng',
    name: '教程',
    slug: 'jiaocheng',
    icon: 'ri-graduation-cap-line',
    description: '编程、设计、音乐、语言等各类实用教程，助你快速成长',
    videoCount: 95,
  },
  {
    id: 'shenghuo',
    name: '生活',
    slug: 'shenghuo',
    icon: 'ri-heart-line',
    description: '美食烹饪、旅行Vlog、家居装饰等生活类精彩视频',
    videoCount: 112,
  },
  {
    id: 'yinyue',
    name: '音乐',
    slug: 'yinyue',
    icon: 'ri-music-line',
    description: 'MV、翻唱、乐器演奏、音乐制作等各类音乐相关内容',
    videoCount: 87,
  },
  {
    id: 'tiyu',
    name: '体育',
    slug: 'tiyu',
    icon: 'ri-football-line',
    description: '赛事集锦、运动教学、健身训练等体育相关视频',
    videoCount: 76,
  },
  {
    id: 'keji',
    name: '科技',
    slug: 'keji',
    icon: 'ri-cpu-line',
    description: '数码评测、科技资讯、AI应用、编程开发等前沿科技内容',
    videoCount: 64,
  },
  {
    id: 'youxi',
    name: '游戏',
    slug: 'youxi',
    icon: 'ri-gamepad-line',
    description: '游戏实况、攻略解说、电竞比赛等精彩游戏内容',
    videoCount: 103,
  },
  {
    id: 'dongman',
    name: '动漫',
    slug: 'dongman',
    icon: 'ri-ghost-line',
    description: '动画短片、二次元创作、动漫解说等内容',
    videoCount: 58,
  },
];

export const videos = [
  {
    id: 1,
    title: '2024年度最佳搞笑短片合集 - 笑到停不下来',
    slug: '2024-funny-shorts-collection',
    categoryId: 'yule',
    categoryName: '娱乐',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20vibrant%20and%20colorful%20thumbnail%20for%20a%20funny%20video%20compilation%20with%20comedy%20elements%2C%20bright%20yellow%20and%20orange%20accents%2C%20playful%20typography%20overlay%2C%20clean%20minimal%20background%20with%20soft%20gradient%2C%20modern%20YouTube-style%20thumbnail%20design&width=640&height=360&seq=video-thumb-01&orientation=landscape',
    duration: '15:28',
    views: 1285000,
    likes: 89200,
    publishDate: '2024-12-15',
    author: '欢乐视频君',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20Chinese%20content%20creator%20avatar%20with%20warm%20smile%2C%20casual%20style%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20soft%20lighting&width=80&height=80&seq=author-01&orientation=squarish',
    description: '精选2024年度最搞笑的短片合集，包含萌宠出糗、搞笑整蛊、爆笑翻车等各种类型，保证让你捧腹大笑！适合所有年龄段观看，减压必备。',
    tags: ['搞笑', '合集', '短片', '娱乐'],
    isHot: true,
    isRecommended: true,
    quality: '4K',
  },
  {
    id: 2,
    title: 'React 19 新特性全面解析 - 从入门到精通',
    slug: 'react-19-new-features',
    categoryId: 'jiaocheng',
    categoryName: '教程',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20coding%20tutorial%20thumbnail%20with%20React%20logo%20elements%2C%20dark%20editor%20background%20with%20syntax%20highlighting%2C%20blue%20and%20white%20color%20scheme%2C%20professional%20tech%20education%20aesthetic%2C%20minimal%20design&width=640&height=360&seq=video-thumb-02&orientation=landscape',
    duration: '42:15',
    views: 356000,
    likes: 28500,
    publishDate: '2024-11-28',
    author: '码农老王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20tech-savvy%20Chinese%20programmer%20avatar%20with%20glasses%2C%20casual%20hoodie%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20professional%20headshot&width=80&height=80&seq=author-02&orientation=squarish',
    description: '深入讲解React 19的各项新特性，包括Server Components、Actions、use() Hook等核心更新。通过实际代码演示，帮助你快速掌握React 19的开发技巧。',
    tags: ['React', '前端', '编程', '教程'],
    isHot: true,
    isRecommended: true,
    quality: '1080P',
  },
  {
    id: 3,
    title: '打卡成都最地道苍蝇馆子 - 本地人才知道的美食地图',
    slug: 'chengdu-hidden-food-gems',
    categoryId: 'shenghuo',
    categoryName: '生活',
    thumbnail: 'https://readdy.ai/api/search-image?query=Delicious%20Sichuan%20cuisine%20food%20photography%20with%20colorful%20spicy%20dishes%20on%20wooden%20table%2C%20warm%20restaurant%20atmosphere%2C%20steaming%20hot%20food%2C%20rich%20red%20chili%20colors%2C%20authentic%20Chinese%20food%20thumbnail%20style&width=640&height=360&seq=video-thumb-03&orientation=landscape',
    duration: '18:42',
    views: 892000,
    likes: 67300,
    publishDate: '2024-12-08',
    author: '吃货小分队',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20food%20blogger%20avatar%20with%20warm%20smile%2C%20casual%20outfit%2C%20clean%20white%20background%2C%20friendly%20portrait%20style&width=80&height=80&seq=author-03&orientation=squarish',
    description: '跟着本地老饕的脚步，探访成都深藏在巷子里的苍蝇馆子。从麻辣火锅到甜水面，每一家都是本地人排长队也要吃的好味道。',
    tags: ['美食', '成都', '探店', '生活'],
    isHot: true,
    isRecommended: false,
    quality: '4K',
  },
  {
    id: 4,
    title: '周杰伦《七里香》民谣吉他指弹改编 - 超好听',
    slug: 'jay-chou-qilixiang-guitar-cover',
    categoryId: 'yinyue',
    categoryName: '音乐',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20acoustic%20guitar%20on%20a%20wooden%20stand%20in%20a%20cozy%20room%20with%20warm%20lighting%2C%20musical%20notes%20floating%20in%20air%2C%20artistic%20music%20thumbnail%2C%20soft%20bokeh%20background%2C%20elegant%20mood&width=640&height=360&seq=video-thumb-04&orientation=landscape',
    duration: '05:36',
    views: 456000,
    likes: 38400,
    publishDate: '2024-12-20',
    author: '吉他手小林',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20musician%20avatar%20with%20guitar%2C%20artistic%20vibe%2C%20warm%20expression%2C%20clean%20white%20background%2C%20casual%20style%20portrait&width=80&height=80&seq=author-04&orientation=squarish',
    description: '用民谣吉他重新演绎周杰伦经典歌曲《七里香》，加入了独特的指弹技巧和和弦编排，带来全新的听觉体验。附吉他谱。',
    tags: ['吉他', '翻弹', '周杰伦', '音乐'],
    isHot: false,
    isRecommended: true,
    quality: '1080P',
  },
  {
    id: 5,
    title: 'NBA经典赛事回顾 - 科比81分之夜全场集锦',
    slug: 'kobe-81-points-highlights',
    categoryId: 'tiyu',
    categoryName: '体育',
    thumbnail: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20court%20action%20shot%20with%20dramatic%20lighting%2C%20player%20in%20purple%20and%20gold%20jersey%2C%20intense%20game%20atmosphere%2C%20sports%20photography%20style%2C%20dynamic%20motion%2C%20arena%20lights&width=640&height=360&seq=video-thumb-05&orientation=landscape',
    duration: '22:10',
    views: 2100000,
    likes: 156000,
    publishDate: '2024-11-15',
    author: '篮球档案馆',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20sports%20enthusiast%20Chinese%20avatar%20with%20passionate%20expression%2C%20sporty%20look%2C%20clean%20white%20background%2C%20professional%20portrait&width=80&height=80&seq=author-05&orientation=squarish',
    description: '回顾科比·布莱恩特职业生涯最伟大的比赛之一——单场81分的传奇之夜。完整集锦配合深度解说，重温黑曼巴的巅峰时刻。',
    tags: ['NBA', '科比', '篮球', '经典'],
    isHot: true,
    isRecommended: true,
    quality: '4K',
  },
  {
    id: 6,
    title: '2025年最值得入手的数码产品 - 年度盘点',
    slug: '2025-best-tech-gadgets',
    categoryId: 'keji',
    categoryName: '科技',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20modern%20tech%20gadgets%20neatly%20arranged%20on%20a%20minimal%20desk%2C%20smartphone%20laptop%20headphones%20smartwatch%2C%20clean%20white%20background%2C%20product%20photography%20style%2C%20soft%20lighting&width=640&height=360&seq=video-thumb-06&orientation=landscape',
    duration: '25:33',
    views: 678000,
    likes: 45200,
    publishDate: '2024-12-01',
    author: '科技观察室',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20tech%20reviewer%20Chinese%20avatar%20with%20modern%20style%2C%20confident%20look%2C%20clean%20white%20background%2C%20professional%20portrait&width=80&height=80&seq=author-06&orientation=squarish',
    description: '盘点2025年最值得入手的数码产品，涵盖手机、笔记本、耳机、智能穿戴等品类。从性价比到旗舰体验，总有一款适合你。',
    tags: ['数码', '评测', '科技', '年度盘点'],
    isHot: false,
    isRecommended: true,
    quality: '4K',
  },
  {
    id: 7,
    title: '《黑神话：悟空》全BOSS无伤速通攻略 - 终极挑战',
    slug: 'black-myth-wukong-no-hit-speedrun',
    categoryId: 'youxi',
    categoryName: '游戏',
    thumbnail: 'https://readdy.ai/api/search-image?query=Black%20Myth%20Wukong%20game%20screenshot%20style%20thumbnail%20with%20epic%20monkey%20king%20character%2C%20dark%20mythological%20atmosphere%2C%20dramatic%20lighting%2C%20ancient%20Chinese%20aesthetic%2C%20action%20pose&width=640&height=360&seq=video-thumb-07&orientation=landscape',
    duration: '55:20',
    views: 1560000,
    likes: 128400,
    publishDate: '2024-12-10',
    author: '游戏高手阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20gamer%20Chinese%20avatar%20with%20energetic%20expression%2C%20casual%20gaming%20style%2C%20clean%20white%20background%2C%20friendly%20portrait&width=80&height=80&seq=author-07&orientation=squarish',
    description: '挑战黑神话悟空全BOSS无伤速通！耗时300小时的深度研究，为你带来最详细的BOSS招式拆解和无伤打法攻略。',
    tags: ['黑神话', '悟空', '速通', '攻略'],
    isHot: true,
    isRecommended: false,
    quality: '4K',
  },
  {
    id: 8,
    title: '一人之下第五季 精彩片段混剪 - 热血高燃',
    slug: 'yiren-zhixia-s5-montage',
    categoryId: 'dongman',
    categoryName: '动漫',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20thumbnail%20with%20dynamic%20martial%20arts%20characters%2C%20vibrant%20ink%20wash%20painting%20style%2C%20dramatic%20action%20scene%2C%20traditional%20Chinese%20aesthetic%20blended%20with%20modern%20animation&width=640&height=360&seq=video-thumb-08&orientation=landscape',
    duration: '08:45',
    views: 723000,
    likes: 54600,
    publishDate: '2024-12-18',
    author: '动漫狂热粉',
    authorAvatar: 'https://readdy.ai/api/search-image?query=An%20anime%20enthusiast%20Chinese%20avatar%20with%20creative%20style%2C%20warm%20expression%2C%20clean%20white%20background%2C%20artistic%20portrait&width=80&height=80&seq=author-08&orientation=squarish',
    description: '一人之下第五季最精彩片段的超燃混剪，搭配高能BGM，带你重温这部国漫神作的每一个名场面。',
    tags: ['一人之下', '国漫', '混剪', '热血'],
    isHot: false,
    isRecommended: true,
    quality: '1080P',
  },
  {
    id: 9,
    title: '零基础学Python - 30天从入门到实战',
    slug: 'python-30-days-beginner',
    categoryId: 'jiaocheng',
    categoryName: '教程',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20Python%20programming%20tutorial%20thumbnail%20with%20code%20snippets%20on%20screen%2C%20clean%20dark%20theme%2C%20Python%20logo%20elements%2C%20beginner-friendly%20vibe%2C%20modern%20education%20design%2C%20soft%20blue%20and%20yellow%20accents&width=640&height=360&seq=video-thumb-09&orientation=landscape',
    duration: '38:20',
    views: 234000,
    likes: 18900,
    publishDate: '2024-11-20',
    author: '码农老王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20tech-savvy%20Chinese%20programmer%20avatar%20with%20glasses%2C%20casual%20hoodie%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20professional%20headshot&width=80&height=80&seq=author-02&orientation=squarish',
    description: '专为零基础小白打造的Python入门教程，每天一节课，30天带你从完全不懂到能够独立完成实战项目。含配套练习和源码。',
    tags: ['Python', '编程', '入门', '教程'],
    isHot: false,
    isRecommended: false,
    quality: '1080P',
  },
  {
    id: 10,
    title: '搞笑综艺名场面TOP50 - 笑到肚子疼的经典瞬间',
    slug: 'funny-variety-show-top50',
    categoryId: 'yule',
    categoryName: '娱乐',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20colorful%20variety%20show%20thumbnail%20with%20comedic%20expressions%2C%20bright%20studio%20lights%2C%20entertainment%20show%20aesthetic%2C%20laughing%20faces%2C%20vibrant%20and%20playful%20design%2C%20clean%20background&width=640&height=360&seq=video-thumb-10&orientation=landscape',
    duration: '28:15',
    views: 987000,
    likes: 76500,
    publishDate: '2024-12-05',
    author: '欢乐视频君',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20Chinese%20content%20creator%20avatar%20with%20warm%20smile%2C%20casual%20style%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20soft%20lighting&width=80&height=80&seq=author-01&orientation=squarish',
    description: '盘点各大综艺节目中让人笑到肚子疼的经典名场面TOP50！从国内到国外，每一个片段都是综艺史上的经典瞬间。',
    tags: ['综艺', '搞笑', '名场面', '娱乐'],
    isHot: true,
    isRecommended: false,
    quality: '1080P',
  },
  {
    id: 11,
    title: '居家健身入门指南 - 无需器械10分钟燃脂训练',
    slug: 'home-workout-no-equipment',
    categoryId: 'tiyu',
    categoryName: '体育',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20home%20workout%20scene%20with%20fitness%20mat%20in%20bright%20living%20room%2C%20natural%20light%2C%20clean%20minimal%20space%2C%20yoga%20and%20exercise%20equipment%2C%20healthy%20lifestyle%20aesthetic%2C%20warm%20and%20inviting%20atmosphere&width=640&height=360&seq=video-thumb-11&orientation=landscape',
    duration: '12:30',
    views: 445000,
    likes: 32100,
    publishDate: '2024-12-12',
    author: '健康生活家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20fitness%20coach%20Chinese%20avatar%20with%20athletic%20build%2C%20energetic%20smile%2C%20clean%20white%20background%2C%20professional%20portrait&width=80&height=80&seq=author-09&orientation=squarish',
    description: '无需任何器械，在家就能完成的高效燃脂训练！每天只需10分钟，科学设计的HIIT动作组合，帮你快速燃脂塑形。',
    tags: ['健身', '居家', '燃脂', '运动'],
    isHot: false,
    isRecommended: false,
    quality: '1080P',
  },
  {
    id: 12,
    title: '古风原创音乐《长安夜雨》- 唯美中国风电音',
    slug: 'changan-night-rain-original',
    categoryId: 'yinyue',
    categoryName: '音乐',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20style%20music%20thumbnail%20with%20traditional%20instruments%20silhouette%2C%20ink%20wash%20painting%20landscape%2C%20rainy%20night%20atmosphere%2C%20lantern%20lights%2C%20poetic%20and%20elegant%20Chinese%20aesthetic%2C%20soft%20golden%20accents&width=640&height=360&seq=video-thumb-12&orientation=landscape',
    duration: '04:20',
    views: 312000,
    likes: 28700,
    publishDate: '2024-12-22',
    author: '古风音乐人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20musician%20Chinese%20avatar%20with%20traditional%20Chinese%20style%20clothing%2C%20elegant%20and%20artistic%2C%20clean%20white%20background%2C%20creative%20portrait&width=80&height=80&seq=author-10&orientation=squarish',
    description: '原创古风电音作品《长安夜雨》，将中国传统乐器与现代电子音乐完美融合。二胡与古筝的悠扬旋律配上节奏感十足的电子节拍，带你穿越千年长安。',
    tags: ['古风', '电音', '原创', '中国风'],
    isHot: true,
    isRecommended: true,
    quality: '无损',
  },
];

export const featuredVideos = videos.filter(v => v.isRecommended);
export const hotVideos = videos.filter(v => v.isHot);

export function getVideosByCategory(slug: string) {
  const category = categories.find(c => c.slug === slug);
  if (!category) return [];
  return videos.filter(v => v.categoryId === category.id);
}

export function getVideoById(id: number) {
  return videos.find(v => v.id === id) || null;
}

export function getCategoryBySlug(slug: string) {
  return categories.find(c => c.slug === slug) || null;
}

export function getRelatedVideos(videoId: number, limit = 4) {
  const video = getVideoById(videoId);
  if (!video) return [];
  return videos
    .filter(v => v.categoryId === video.categoryId && v.id !== videoId)
    .slice(0, limit);
}